import { parseJwt } from "../../helper/genericFunction";
import locale from "antd/es/date-picker/locale/en_US";
import dayjs from "dayjs";

const UseDatePickerLocale = () => {
  let languageJson = {
    "en": true,
    "en-HS": true,
    "zh": true,
  };
  let currentLanguage = sessionStorage?.getItem("CURRENT_LANGUAGE")
    ? languageJson?.hasOwnProperty(sessionStorage?.getItem("CURRENT_LANGUAGE"))
      ? sessionStorage?.getItem("CURRENT_LANGUAGE")
      : "en"
    : "en";

  const isMonthPickerFormatAvailable = () => {
    const tokenData = parseJwt(sessionStorage.getItem("token"));
    return currentLanguage === "zh";
  };

  let updatedLocale = locale;

  if (isMonthPickerFormatAvailable()) {
    updatedLocale = {
      ...locale,
      lang: {
        ...locale.lang,
        shortMonths: [
          "一月", "二月", "三月", "四月", "五月", "六月",
          "七月", "八月", "九月", "十月", "十一月", "十二月"
        ],
        weekdays: [
          "星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"
        ],
        // shortWeekDays: ["日", "一", "二", "三", "四", "五", "六"],
        // shortWeekDays: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
        shortWeekDays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
        today: "今天"
      },
    };
  }

  return updatedLocale;
};

export default UseDatePickerLocale;
